"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfiguration = exports.configurationContext = exports.ConfigurationProvider = void 0;
var _react = require("react");
const configurationContext = exports.configurationContext = /*#__PURE__*/(0, _react.createContext)({
  identityUrl: '',
  globalApiUrl: '',
  staticApiUrl: '',
  tenant: '',
  processContext: '',
  currentLanguage: '',
  formattedToken: '',
  token: ''
});
const ConfigurationProvider = exports.ConfigurationProvider = configurationContext.Provider;
const useConfiguration = () => (0, _react.useContext)(configurationContext);
exports.useConfiguration = useConfiguration;
//# sourceMappingURL=configurationContext.js.map